export const getColor = (points) => {
  if (points > 750) return "gold";
  if (points > 500) return "silver";
  if (points > 250) return "bronze";
  return "blue";
};
